import React from 'react';
import './SmallLoadingSpinner.css';

export const SmallLoadingSpinner = (
  <div className="small-spinner loading"></div>
)
